module.exports = __webpack_public_path__ + "img/hotelrunner.e48cf16b.png";